export function propsAreNotEmpty<T>(value: Partial<T>): value is T {
  return Object.values(value).every((v) => v !== undefined);
}
